import axios from 'axios'
import router from './router'

// Import ENV config
import config from '../config'

export const http = {
  install(Vue) {
    Vue.prototype.$http = Vue.http = axios.create({
      baseURL: config.general.apiUrl,
      headers: {
        'Content-Type': 'application/json',
        secret: localStorage.getItem('secret') || ''
      }
    })
  }
}

export { router }